import { Component, OnInit, Input } from '@angular/core';
import { AlertService } from '../../shared/services/alert.service';
import { ApiService } from '../../shared/services/api.service';
import { FormControlService } from '../../shared/services/form-control.service';
import { File } from '../../models/files/files.model';
import { Contained } from '../../models/editors/contained.model';
import { InlineFormBase } from '../../shared/components/base/inline-form/inline-form.base.component';

@Component({
  selector: 'swb-favicon-ico',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})
export class FaviconIcoComponent extends InlineFormBase<File> implements OnInit {

  public url = 'favicon-ico';

  public headerTitle = 'Favicon';
  public get fieldsConfig(): Array<any> {
    return [
      new Contained({
        key: 'file_id',
        label: 'Favicon',
        entity: this.entity,
        upload: true,
        isHalf: true
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }
}
